import { graphql, Link } from 'gatsby';
import React from 'react';
import Layout from '../components/Layout';
import * as styles from '../styles/home.module.css';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

interface IImageData {
  data: {
    file: FileNode;
  };
}

export default ({ data }: IImageData) => {
  const image = getImage(data.file);
  return (
    <Layout>
      <section className={styles.header}>
        <div>
          <h2>Design</h2>
          <h3>Develop & Deploy</h3>
          <p>UI designer & web developer based in Glasgow</p>
          <Link className={styles.btn} to="/projects">
            My Portfolio Projects
          </Link>
        </div>

        <GatsbyImage className={styles.image} image={image!} alt="Banner" />
      </section>
    </Layout>
  );
};

export const query = graphql`
  query Banner {
    file(relativePath: { eq: "banner.png" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH, placeholder: BLURRED)
      }
    }
  }
`;
